module.exports = __webpack_public_path__ + "static/media/442.0cd84113.jpg";